import axios from 'axios'
import { StudentAwardPreviewResultSchema } from './schema'
import { parseRequestError } from '@/common/utilities.ts'

export const getStudentAwardPreview = async ({
  programId,
  purseId,
  studentIds,
}: {
  programId: number
  purseId: number
  studentIds: number[]
}) => {
  try {
    const response = await axios.get(
      `/programs/${programId}/purses/${purseId}/student_award_preview`,
      {
        params: {
          student_ids: studentIds,
        },
      }
    )
    return StudentAwardPreviewResultSchema.parse(response.data)
  } catch (e) {
    throw parseRequestError(e)
  }
}
